<div class="contenido">
    <div class="row secc1">
        <div class="col left">
            <h2>
                <i class="fas fa-arrow-left" routerLink="/blog"></i>Blog Triidy
            </h2>
            <h4>
                Inspirate, emprende, vende y crece.
            </h4>
        </div>
        <div class="col right">
            <p>Blog - Marketing</p>
            <p>15 Nov 2020</p>
        </div>
    </div>
    <div class="row secc2">
        <div class="col left">
            <div class="row temas" id="temas">
                <h2>¿Cómo hacer dropshipping?</h2>
                <img class="image" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Example-new.png" alt="">
                <p>
                    A medida que el mundo avanza, cada vez más modelos de negocio comienzan a adaptarse a las tendencias digitales para no solo crear oportunidades donde antes no existían, sino también para simplificar el proceso de compra-venta en cada transacción.
                    <br> El dropshipping es uno de los casos más relevantes. Este modelo de negocio, caracterizado por no requerir de inventario ni capital para dar pie a un negocio rentable, surgió a mediados del siglo XX como una estrategia para extender
                    el alcance de grandes marcas y empresas.
                    <br> Gracias al comercio electrónico, se ha convertido en una de las formas más atractivas de hacer negocios en la actualidad. Mediante el dropshipping podremos aliarnos a cientos de proveedores de todo el mundo para trabajar como
                    intermediarios entre estos y el consumidor final.
                    <br> Se trata de un modelo de negocio que recompensa las ventas por volumen al disminuir los márgenes de ganancia de cada intermediario, que a la vez posibilita la comercialización de marcas blancas bajo una imagen propia.
                    <br> En esta sección podrás encontrar decenas de artículos y guías prácticas sobre dropshipping en las que no solo te enseñaremos, paso a paso, qué debes tener en cuenta al momento de crear un negocio bajo esta modalidad, sino también
                    qué casos de éxito puedes seguir para tener una tienda virtual realmente rentable.
                </p>
            </div>
        </div>
        <div class="col right navegador">
            <div class="boxx" id="cajaSus">
                <h3>Únete a Triidy</h3>
                <p>Recibe consejos sobre comercio electrónico, marketing online, redes sociales, negocios y mucho más.
                </p>
                <p class="intros">
                    <input class="inputs" type="text" id="nombre2" required />
                    <label for="nombre" alt="Nombres" placeholder="Nombres"></label>
                </p>
                <p class="intros">
                    <input class="inputs" type="email" id="email2" required />
                    <label for="email" alt="Correo electrónico" placeholder="Correo electrónico"></label>
                </p>
                <button class="btn">Suscríbete</button>
            </div>
        </div>
    </div>
    <div class="row secc3">
        <p>Compartir en:</p>
        <p>
            <img class="icon" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Facebookdet-new.png" alt="">
            <img class="icon" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Twitterdet-new.png" alt="">
            <img class="icon" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Linkedindet-new.png" alt="">
            <img class="icon" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Whatsappdet-new.png" alt="">
        </p>
    </div>
    <div class="row secc4">
        <p>Registrate para recibir las últimas noticias y novedades acerca de Triidy.</p>
        <p class="intros">
            <input class="inputs" type="text" id="nombre" required />
            <label for="nombre" alt="Nombres" placeholder="Nombres"></label>
        </p>
        <p class="intros">
            <input class="inputs" type="email" id="email" required />
            <label for="email" alt="Correo electrónico" placeholder="Correo electrónico"></label>
        </p>
        <button class="btn">Suscríbete</button>
    </div>
    <div class="row secc5">
        <div class="row temas" id="temasRela">
            <div class="col-6 blogs" *ngFor="let ben of Relacionados">
                <div class="card2">
                    <div class="contimg">
                        <img class="image" [src]="ben.imagen" alt="">
                    </div>
                    <div class="contentext">
                        <h3>{{ ben.titulo }}</h3>
                        <p class="fech"><span>Marketing</span>15 Nov 2020</p>
                        <p>{{ ben.parrafo }}</p>
                        <p><a class="see" routerLink="/blog/detalle">Ver artículo<i class="fas fa-arrow-right"></i></a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row secc6">
        <h2>Gestiona y organiza tu tienda virtual desde tu computador o desde tu celular.</h2>
        <button class="btn">Registrate Ahora</button>
    </div>
    <div class="row secc7">
        <p>Con el apoyo y acompañamiento de:</p>
        <img src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Acompa12-new.png" alt="">
    </div>
</div>